import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router-dom";
import { AppContextProvider } from "./AppContext";
import Container from "./Components/Common/Container";
import { Navbar } from "./Components/Common/Navbar";
import { router } from "./routes";

function App() {
  return (
    <>
      <Toaster
        toastOptions={{
          duration: 3000,
          position: "bottom-right",
        }}
      />
      <AppContextProvider>
        <Navbar />
        <div className="main-content">
          <Container>
            <RouterProvider router={router} />
          </Container>
        </div>
      </AppContextProvider>
    </>
  );
}

export default App;
